module.exports = __webpack_public_path__ + "img/C03TechCalltoArms_ua.fb6a4c85.webp";